export enum ErrorType {
  DUPLICATED_VALUE = 'DUPLICATED_VALUE',
  DUPLICATED_VALUE_IN_DB = 'DUPLICATED_VALUE_IN_DB',
  FILE_TOO_LARGE = 'FILE_TOO_LARGE',
  REQUEST_TIMEOUT = 'REQUEST_TIMEOUT',
  INSUFFICIENT_COUPON_STOCK = 'INSUFFICIENT_COUPON_STOCK',
  INVALID_MDP_ID = 'INVALID_MDP_ID',
  LOG_OUT = 'LOG_OUT',
  OUT_OF_STOCK_ERROR = 'OUT_OF_STOCK_ERROR',
  PURCHASE_ERROR = 'PURCHASE_ERROR',
  REFUND_ERROR = 'REFUND_ERROR',
  UNPURCHASED = 'UNPURCHASED',
}
